import { Box, Grid2, Typography } from "@mui/material";
import { Cube, FilmSlate, FilmStrip, Heartbeat } from "phosphor-react";
import React, { useEffect, useState } from "react";
import { fget } from "../../../../API/callsAPI";
import commonStyles from "../../../../Utils/commonStyles";
import CompletePercentage from "../../../Utilities/CompletePercentage/CompletePercentage";
import Loader from "../../../Utilities/Loader/Loader";

const ProjectHealthWidget = ({ projectId, projectDetails }) => {
  const commonClasses = commonStyles();
  const [taskCompletePercentage, setTaskCompletePercentage] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const getHealth = async () => {
      try {
        const res = await fget({ url: `project/${projectId}/task-widget/` });
        setTaskCompletePercentage(
          (res?.data?.completed_tasks / res?.data?.total_tasks).toFixed(1) *
            100 ?? 0
        );
        setIsLoading(false);
      } catch (error) {
        console.log(error);
        setIsLoading(false);
      }
    };
    getHealth();
  }, [projectId]);

  return (
    <Box className={commonClasses.bigWidgetRoot}>
      <Box className={commonClasses.widgetTitleContainer}>
        <Box className={commonClasses.flexAndGap8Px}>
          <Heartbeat size={22} fill="#E24A82" fillOpacity={1} weight="fill" />
          <Typography className={commonClasses?.widgetsTitle}>
            Project Health
          </Typography>
        </Box>
        {/* <Box className={commonClasses.flexAndGap8Px}>
          <ArrowsOut size={20} color="gray" />
        </Box> */}
      </Box>
      {isLoading ? (
        <Loader />
      ) : (
        <Box
          p={2}
          borderRadius="10px"
          sx={{
            bgcolor: "#1F222E",
            height: "91%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          <Box
            className={commonClasses.flexAndGap8Px}
            sx={{ gap: "20px !important" }}
          >
            <Box className={commonClasses.flexCenter}>
              <CompletePercentage
                percentage={taskCompletePercentage}
                size={80}
                stroke={10}
                showPercentage={true}
              />
            </Box>
            <Box>
              <Typography
                sx={{
                  fontSize: {
                    xs: "12px !important",
                    sm: "12px !important",
                    md: "12px !important",
                    lg: "12px !important",
                    xl: "14px !important",
                  },
                  color: "#606479",
                }}
              >
                Project Completion state
              </Typography>
              <Typography
                sx={{
                  fontSize: {
                    xs: "16px !important",
                    sm: "18px !important",
                    md: "18px !important",
                    lg: "18px !important",
                    xl: "20px !important",
                  },
                  fontWeight: 600,
                  py: 1,
                  color: "#C4C62D",
                }}
              >
                Healthy & On Time
              </Typography>
              <Typography
                sx={{
                  fontSize: {
                    xs: "12px !important",
                    sm: "12px !important",
                    md: "12px !important",
                    lg: "12px !important",
                    xl: "14px !important",
                  },
                }}
              >{`You’re making good progress with tasks, shots and assets.`}</Typography>
            </Box>
          </Box>
          <Box mt={2}>
            <Grid2 container spacing={1}>
              <Grid2 size={6}>
                <Box
                  borderRadius="5px"
                  p={1}
                  sx={{
                    bgcolor: "#252A38",
                  }}
                >
                  <Box className={commonClasses.flexAndGap8Px}>
                    <FilmStrip size={20} />
                    <Typography
                      sx={{
                        fontSize: {
                          xs: "10px !important",
                          sm: "12px !important",
                          md: "12px !important",
                          lg: "14px !important",
                          xl: "16px !important",
                        },
                      }}
                    >
                      Sequences
                    </Typography>
                  </Box>
                  {/* <Typography
                      sx={{
                        mt: "4px",
                        color: "#44B927",
                        fontSize: {
                          xs: "10px !important",
                          sm: "12px !important",
                          md: "12px !important",
                          lg: "12px !important",
                          xl: "14px !important",
                        },
                      }}
                    >
                      + 10 this week
                    </Typography> */}
                  <Typography
                    sx={{
                      fontSize: {
                        xs: "14px !important",
                        sm: "16px !important",
                        md: "16px !important",
                        lg: "18px !important",
                      },
                      mt: 1,
                      fontWeight: 500,
                    }}
                  >
                    {projectDetails?.trackables?.sequences}
                    {/* <span
                      style={{
                        color: "#6C65D9",
                      }}
                    >
                      400
                    </span> */}
                  </Typography>
                </Box>
              </Grid2>
              <Grid2 size={6}>
                <Box
                  borderRadius="5px"
                  p={1}
                  sx={{
                    bgcolor: "#252A38",
                  }}
                >
                  <Box className={commonClasses.flexAndGap8Px}>
                    <FilmSlate size={20} />
                    <Typography
                      sx={{
                        fontSize: {
                          xs: "10px !important",
                          sm: "12px !important",
                          md: "12px !important",
                          lg: "14px !important",
                          xl: "16px !important",
                        },
                      }}
                    >
                      Shots
                    </Typography>
                  </Box>
                  <Typography
                    sx={{
                      fontSize: {
                        xs: "14px !important",
                        sm: "16px !important",
                        md: "16px !important",
                        lg: "18px !important",
                      },
                      mt: 1,
                      fontWeight: 500,
                    }}
                  >
                    {projectDetails?.trackables?.shots}
                  </Typography>
                </Box>
              </Grid2>

              <Grid2 size={6}>
                <Box
                  borderRadius="5px"
                  p={1}
                  sx={{
                    bgcolor: "#252A38",
                  }}
                >
                  <Box className={commonClasses.flexAndGap8Px}>
                    <Cube size={20} />
                    <Typography
                      sx={{
                        fontSize: {
                          xs: "10px !important",
                          sm: "12px !important",
                          md: "12px !important",
                          lg: "14px !important",
                          xl: "16px !important",
                        },
                      }}
                    >
                      Assets
                    </Typography>
                  </Box>
                  <Typography
                    sx={{
                      fontSize: {
                        xs: "14px !important",
                        sm: "16px !important",
                        md: "16px !important",
                        lg: "18px !important",
                      },
                      mt: 1,
                      fontWeight: 500,
                    }}
                  >
                    {projectDetails?.trackables?.assets}
                  </Typography>
                </Box>
              </Grid2>
              <Grid2 size={6}>
                <Box
                  borderRadius="5px"
                  p={1}
                  sx={{
                    bgcolor: "#252A38",
                  }}
                >
                  <Box className={commonClasses.flexAndGap8Px}>
                    <Typography
                      sx={{
                        fontSize: {
                          xs: "10px !important",
                          sm: "12px !important",
                          md: "12px !important",
                          lg: "14px !important",
                          xl: "16px !important",
                        },
                      }}
                    >
                      Versions Submitted
                    </Typography>
                  </Box>
                  <Typography
                    sx={{
                      fontSize: {
                        xs: "14px !important",
                        sm: "16px !important",
                        md: "16px !important",
                        lg: "18px !important",
                      },
                      mt: 1,
                      fontWeight: 500,
                    }}
                  >
                    {Number(projectDetails?.trackables?.asset_versions) +
                      Number(projectDetails?.trackables?.shot_versions)}
                  </Typography>
                </Box>
              </Grid2>
            </Grid2>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default ProjectHealthWidget;
